export default __webpack_public_path__ + "media/elevenia.8e619c82.png";